import React from 'react'
import style from './GreyBlock.less'
import PropTypes from 'prop-types'

const getStyle = (props) => ({
  height: (props.height) ? `${props.height}px` : 'auto',
  width: (props.width) ? `${props.width}px` : '100%',
  display: (props.block) ? 'block' : 'inline-block',
  marginRight: (props.right) ? '8px' : '0px',
  marginTop: (props.top) ? '8px' : '0px',
})

const GreyBlock = (props) => (
  <div className={style.main} style={getStyle(props)} />
)

GreyBlock.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  block: PropTypes.bool,
}

export default GreyBlock
